export default "__VITE_ASSET__e22a3af9__"